module.exports = __webpack_public_path__ + "media/files/terms_v2-09faf6355bb2d493afea3338a5dc2a4e.docx";